/** Host input preferences stay on this device; no account or provider data. */
export const INPUT_STORAGE_KEY = 'streamit.input.v1';
export const MODIFIED_SEEK_STEPS = [5, 10, 15, 30, 60] as const;
export type InputPreferences = { keyboard: boolean; gamepad: boolean; shiftBackward: typeof MODIFIED_SEEK_STEPS[number]; shiftForward: typeof MODIFIED_SEEK_STEPS[number] };
export const DEFAULT_INPUT: InputPreferences = { keyboard: true, gamepad: false, shiftBackward: 30, shiftForward: 30 };
export function inputPreferences(value: unknown): InputPreferences {
  const v = value && typeof value === 'object' ? value as Record<string, unknown> : {};
  const step = (value: unknown) => typeof value === 'number' && MODIFIED_SEEK_STEPS.some(n => n === value) ? value as typeof MODIFIED_SEEK_STEPS[number] : 30;
  return { keyboard: typeof v.keyboard === 'boolean' ? v.keyboard : true, gamepad: typeof v.gamepad === 'boolean' ? v.gamepad : false,
    shiftBackward: step(v.shiftBackward), shiftForward: step(v.shiftForward) };
}
type PreferenceStorage = Pick<Storage, 'getItem' | 'setItem'>;
export function readInputPreferences(storage?: PreferenceStorage): InputPreferences {
  try { const v = JSON.parse((storage ?? localStorage).getItem(INPUT_STORAGE_KEY) || 'null'); return inputPreferences(v?.version === 1 ? v.preferences : null); }
  catch { return inputPreferences(null); }
}
export function saveInputPreferences(value: unknown, storage?: PreferenceStorage): boolean {
  try { const target = storage ?? localStorage, encoded = JSON.stringify({ version: 1, preferences: inputPreferences(value) });
    target.setItem(INPUT_STORAGE_KEY, encoded); return target.getItem(INPUT_STORAGE_KEY) === encoded; }
  catch { return false; }
}
